import { render } from "./shippingContents.vue?vue&type=template&id=a2c148b2&scoped=true"
import script from "./shippingContents.vue?vue&type=script&lang=js"
export * from "./shippingContents.vue?vue&type=script&lang=js"

import "./shippingContents.vue?vue&type=style&index=0&id=a2c148b2&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2c148b2"]])

export default __exports__